import Footer from '../commons/Footer'
import Navbar from '../commons/Navbar'

import breadcrumbshape1 from '../img/breadcrumb/breadcrumb-shape-1.png'
import breadcrumbshape2 from '../img/breadcrumb/breadcrumb-shape-2.png'
import breadcrumbsub1 from '../img/breadcrumb/breadcrumb-sub-1.png'


const RefundPolicy = () => {
  return (
    <div>
      {/* tp-offcanvus-area-start */}

      <div className="body-overlay" />
      {/* tp-offcanvus-area-end */}
      <Navbar />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <main>
            {/* breadcrumb-area-start */}
            <div className="breadcrumb__area breadcrumb-height p-relative blue-bg-2">
              <div className="breadcrumb__shape-1">
                <img src={breadcrumbshape1} alt="" />
              </div>
              <div className="breadcrumb__shape-2">
                <img src={breadcrumbshape2} alt="" />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-8 col-lg-7">
                    <div className="breadcrumb__content">
                      <h3 className="breadcrumb__title tp-char-animation">
                        Refund Policy
                      </h3>
                      <div className="breadcrumb__list tp-title-anim">
                        <span className="child-one">
                          <a
                            href="/"
                            style={{ textDecoration: 'none', color: 'white' }}
                          >
                            Home
                          </a>
                        </span>
                        <span className="dvdr">
                          <i className="fal fa-angle-right" />
                        </span>
                        <span className="dvdr">
                        </span>
                        <span>RefundPolicy</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-5 col-lg-4 text-center text-md-end">
                    <div className="breadcrumb__img p-relative text-start z-index">
                      <div
                        className="breadcrumb__sub-img wow tpfadeUp"
                        data-wow-duration=".9s"
                        data-wow-delay=".4s"
                      >
                        <img src={breadcrumbsub1} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* breadcrumb-area-end */}
            {/* service-details-area-start */}
             <div className="bg-white text-black min-h-screen flex justify-center items-start py-10 px-4">
                <div className="w-full max-w-5xl">
                    <h1 className="text-3xl font-bold mb-4">Refund Policy</h1>

                    <p className="mb-4">
                    LONO (Busicon Services Private Limited) strives to provide high-quality finance and business
                    technology services, including but not limited to loans, insurances, account openings, tax filings,
                    business compliances, business registrations, documentation services, and agreement drafting.
                    Please read our Refund Policy carefully to understand how refunds are handled for payments made on our platform.
                    </p>

                    <h5 className="text-2xl font-semibold mb-2">1. Refund Eligibility</h5>
                    <ul className="list-disc list-inside mb-4">
                    <li>
                        Platform Fees, Login Fees, Documentation Charges, and Registration Charges are non-refundable
                        once payment has been successfully processed, except in cases where:
                        <ul className="list-disc list-inside ml-5">
                        <li>A duplicate payment has been made.</li>
                        <li>A payment has been made in error and no service has been initiated.</li>
                        </ul>
                    </li>
                    <li>
                        Service-based fees are non-refundable once the work has commenced or the application has been filed with relevant authorities.
                    </li>
                    </ul>

                    <h5 className="text-2xl font-semibold mb-2">2. Refund Requests</h5>
                    <ul className="list-disc list-inside mb-4">
                    <li>Submit a written request within 7 days of the payment date.</li>
                    <li>
                        Email your refund request to <a href="mailto:help@lono.org.in" className="text-blue-700 underline">help@lono.org.in</a> with:
                        <ul className="list-disc list-inside ml-5">
                        <li>Your full name and contact information</li>
                        <li>Payment transaction ID or receipt</li>
                        <li>Service(s) paid for</li>
                        <li>Reason for the refund request</li>
                        </ul>
                    </li>
                    </ul>

                    <h5 className="text-2xl font-semibold mb-2">3. Refund Approval</h5>
                    <ul className="list-disc list-inside mb-4">
                    <li>Each refund request will be evaluated case-by-case.</li>
                    <li>If approved, refunds will be processed to the original payment method within 7–14 business days.</li>
                    </ul>

                    <h5 className="text-2xl font-semibold mb-2">4. Non-Refundable Situations</h5>
                    <ul className="list-disc list-inside mb-4">
                    <li>When the requested service has already been delivered or submitted.</li>
                    <li>If incorrect or incomplete information causes delays or rejection.</li>
                    <li>If the user fails to cooperate with documentation or compliance steps.</li>
                    <li>If the refund request is made after the allowed time frame.</li>
                    </ul>

                    <h5 className="text-2xl font-semibold mb-2">5. Contact Us</h5>
                    <p className="mb-1">
                    Email: <a href="mailto:help@lono.org.in" className="text-blue-700 underline">help@lono.org.in</a>
                    </p>
                    <p className="mb-1">
                    Website: <a href="https://lono.co.in" className="text-blue-700 underline" target="_blank" rel="noopener noreferrer">lono.co.in</a>
                    </p>
                    <p className="mb-4">Mobile: +91 765 893 4523</p>

                    <p className="text-sm text-gray-600">
                    More info: <a href="https://lono.co.in/" target="_blank" rel="noopener noreferrer" className="underline text-blue-700">https://lono.co.in/</a>
                    </p>
                </div>
                </div>

            {/* service-details-area-end */}
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
